<template>
	<div class="cartButtonMobile">
		<svg
			@click="cartTrigger"
			width="29"
			height="29"
			viewBox="0 0 29 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8.46591 7.74595L7.72497 4.57052C7.57441 3.92524 6.99914 3.46875 6.33653 3.46875H3.8415C3.05409 3.46875 2.41577 4.10707 2.41577 4.89448C2.41577 5.6819 3.05409 6.32022 3.8415 6.32022H5.20518L7.07433 14.3113L7.95187 19.5766C8.04361 20.127 8.56811 20.4958 9.11715 20.396L23.19 17.8373C23.5646 17.7692 23.868 17.4943 23.9726 17.1282L26.289 9.02067C26.4716 8.38186 25.9919 7.74595 25.3275 7.74595H8.46591Z"
				fill="#E02D00"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.334 23.5625C19.334 24.5635 20.1455 25.375 21.1465 25.375C22.1475 25.375 22.959 24.5635 22.959 23.5625C22.959 22.5615 22.1475 21.75 21.1465 21.75C20.1455 21.75 19.334 22.5615 19.334 23.5625ZM8.45898 23.5625C8.45898 24.5635 9.27047 25.375 10.2715 25.375C11.2725 25.375 12.084 24.5635 12.084 23.5625C12.084 22.5615 11.2725 21.75 10.2715 21.75C9.27047 21.75 8.45898 22.5615 8.45898 23.5625Z"
				fill="#E02D00"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'CartButtonMobile',
	methods: {
		cartTrigger() {
			this.$emit('openCart');
		},
	},
};
</script>
